import {Component, ChangeDetectionStrategy, OnInit, OnChanges, SimpleChanges, Input} from "@angular/core";
import {LogManager, LogCat} from "../../../../common/log";

@Component({
	selector: 'cp-layout-box',
	templateUrl: './layout.box.html',
	styleUrls: ['./layout.box.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class LayoutBoxComponent implements OnChanges, OnInit {

	@Input() ignoreTitle:boolean = false;

	constructor() {
		LogManager.debug(LogCat.UI.LayoutBox,"LayoutBoxComponent.constructor");
		// console.log("LayoutBoxComponent.constructor");
	}

	ngOnChanges(changes: SimpleChanges) {
		LogManager.debug(LogCat.UI.LayoutBox,"LayoutBoxComponent.ngOnChanges");
		// console.log("LayoutBoxComponent.ngOnChanges");
	}

	ngOnInit() {
		LogManager.debug(LogCat.UI.LayoutBox,"LayoutBoxComponent.ngOnInit");
		// console.log("LayoutBoxComponent.ngOnInit");
	}
}
